import React from 'react';
import { MobilePriceChart } from './MobilePriceChart';
import { Prediction } from '../../types/predictions';
import { Theme } from '../../theme';

interface MobileChartWrapperProps {
  predictions: Prediction[];
  activePredictions: number[];
  chartData: Array<{ time: string; value: number }>;
  isDarkMode: boolean;
  theme: Theme;
  userContestPrediction?: number | null;
  userHandle?: string;
}

const MobileChartWrapper: React.FC<MobileChartWrapperProps> = ({
  predictions,
  activePredictions,
  chartData,
  isDarkMode,
  theme,
  userContestPrediction,
  userHandle
}) => {
  const instanceId = React.useRef(Math.random().toString(36).substr(2, 9));
  
  // Debug: Log all received props
  const timestamp = new Date().toLocaleTimeString();
  console.log('📱 Mobile Chart received:', {
    predictions: predictions.length,
    activePredictions,
    chartData: chartData.length,
    isDarkMode,
    theme: !!theme
  });
  
  // Filter to only actual price data (no future predictions)
  const now = new Date();
  const historicalData = chartData.filter(point => {
    const pointDate = new Date(point.time);
    return pointDate <= now && point.value > 0;
  });

  // If we have historical data, use only that for better viewport
  const processedData = historicalData.length > 0 ? historicalData : chartData;

  // TEMPORARILY DISABLE FILTERING: Pass all predictions for debugging
  const recentPredictions = predictions; // Don't filter anything for now
  

  return (
    <MobilePriceChart
      predictions={recentPredictions}
      activePredictions={activePredictions}
      chartData={processedData}
      isDarkMode={isDarkMode}
      theme={theme}
      userContestPrediction={userContestPrediction}
      userHandle={userHandle}
    />
  );
};

export default MobileChartWrapper;
